import { render, staticRenderFns } from "./POptionBar.vue?vue&type=template&id=8bfd6f50&scoped=true"
import script from "./POptionBar.vue?vue&type=script&lang=ts"
export * from "./POptionBar.vue?vue&type=script&lang=ts"
import style0 from "./POptionBar.vue?vue&type=style&index=0&id=8bfd6f50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bfd6f50",
  null
  
)

export default component.exports